import React, { useEffect, useState, useRef } from "react";
import { AddCircleOutline, Delete, Edit } from "@mui/icons-material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Button,
  IconButton,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import EmployeeTaxSlabVeiwController from "../../redux/actions/EmployeeTaxSlabApiAction";

import "../../styles/styles.css";
import "../../styles/layout.css";
import ReusableGrid from "../../components/ag grid/ReusableGrid";
import ExportButton from "../../components/ag grid/ExportButton";
import PageSizeSelector from "../../components/ag grid/PageSizeSelector";
import EmpTaxSlabModal from "./AddEmployeeTaxSlab";


const EmpTaxSlabList = () => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);

  const { getemployeeTax, deleteEmployeeTax } = EmployeeTaxSlabVeiwController();
  const { employee_tax } = useSelector((state) => state.emp_tax);

  const [showModal, setShowModal] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewRow, setViewRow] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [pageSize, setPageSize] = useState(10);

  // Fetch data
  useEffect(() => {
    dispatch(getemployeeTax());
  }, [dispatch]);

  // CRUD handlers
  const handleDelete = (id) => dispatch(deleteEmployeeTax(id));
  const handleEdit = (row) => {
    setEditRow(row);
    setShowModal(true);
  };
  const handleView = (row) => {
    setViewRow(row);
    setViewModalOpen(true);
  };

  // Ag-Grid column definitions
  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      maxWidth: 50,
      pinned: "left",
    },
    {
      headerName: "SR.No",
      valueGetter: (params) => params.node.rowIndex + 1,
      maxWidth: 80,
    },
    {
      headerName: "Financial Year",
      field: "financial_year",
      flex: 1,
    },
    {
      headerName: "Tax Slab",
      field: "tax_slab_master_name", // Adjust if your API returns different key
      flex: 1,
    },
    {
      headerName: "Accepted",
      field: "is_accepted",
      maxWidth: 120,
      cellRenderer: (params) => (params.value ? "Yes" : "No"),
    },
    {
      headerName: "Actions",
      pinned: "right",
      minWidth: 150,
      maxWidth: 180,
      cellRenderer: (params) => (
        <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
          {/* <Tooltip title="View">
            <IconButton
              color="primary"
              size="small"
              onClick={() => handleView(params.data)}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip> */}
          <Tooltip title="Edit">
            <IconButton size="small" onClick={() => handleEdit(params.data)}>
              <Edit fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton
              size="small"
              sx={{ color: "#d32f2f" }}
              onClick={() => handleDelete(params.data.id)}
            >
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <div>
      {/* Top action bar */}
      <div
        className="d-flex flex-wrap mb-3 gap-2"
        style={{ justifyContent: "space-between" }}
      >
        <div className="mt-2">
          <Button
            variant="contained"
            startIcon={<AddCircleOutline />}
            onClick={() => {
              setEditRow(null);
              setShowModal(true);
            }}
            sx={{
              borderRadius: "8px",
              backgroundColor: "#1976d2",
              textTransform: "none",
              paddingX: 2,
              height: "40px",
              fontSize: "0.875rem",
            }}
          >
            Add Employee Tax Slab
          </Button>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <ExportButton
            gridRef={gridRef}
            fileName="EmployeeTaxSlabs.xlsx"
            exportColumns={[
              "financial_year",
              "tax_slab_master_name",
              "is_accepted",
            ]}
            disabled={selectedRows.length === 0}
            size="medium"
          />
          <PageSizeSelector
            pageSize={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
          />
        </div>
      </div>

      {/* Grid */}
      <div className="ag-theme-material" style={{ height: "70vh" }}>
          <ReusableGrid
            rowData={employee_tax}
            columnDefs={columnDefs}
            gridRef={gridRef}
            pagination={true}
            pageSize={pageSize}
            onSelectionChanged={(rows) => setSelectedRows(rows)}
          />
    
      </div>

      {/* Add/Edit Modal */}
      <EmpTaxSlabModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        initialData={editRow}
      />

      {/* View Modal */}
      {/* <EmpTaxSlabViewModal
        show={viewModalOpen}
        handleClose={() => setViewModalOpen(false)}
        data={viewRow}
      /> */}
    </div>
  );
};

export default EmpTaxSlabList;
